const templates = [
    {
        'id': 0,
        'template': '{{Sentence A}} After that, {{Sentence B}}',
    },
    {
        'id': 1,
        'template': '{{Sentence A}} Later, {{Sentence B}}',
    },
    {
        'id': 2,
        'template': '{{Sentence A}} Subsequently, {{Sentence B}}',
    },
]

export default templates;